import { render, staticRenderFns } from "./BTablePublicationMunMeh.vue?vue&type=template&id=57e98ed3&"
import script from "./BTablePublicationMunMeh.vue?vue&type=script&lang=js&"
export * from "./BTablePublicationMunMeh.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports